<div class="container" [@slideShow] *ngIf="showStatus">
  <ul>
    <li (click)="logout()">
      <label for="">
        <span>Sign Out</span>
        <!-- <i class="fas fa-sign-out-alt fa-fw"></i> -->
        <img src="../images/site-icons/logout-btn.svg">
      </label>
    </li>
    <li id="divMyInfo" (click)="openPersonalInformation($event)">
      <label for="">
        <span>My Information</span>
        <!-- <i class="fas  fa-user fa-fw"></i> -->
        <img src="../images/site-icons/myInformation.svg">
      </label>
    </li>
    <li *ngIf="!currentUserModel.hideSOH" (click)="openPersonalSubscription($event)">
      <label for="">
        <span>My Subscription</span>
        <!-- <i class="fas  fa-user fa-fw"></i> -->
        <img src="../images/site-icons/mySubscription.svg">
      </label>
    </li>
    <li (click)="openSales($event)">
      <label for="">
        <span>Sales Documents</span>
        <!-- <i class="fas fa-file-alt fa-fw"></i> -->
        <img src="../images/site-icons/salesDocument.svg">
      </label>
    </li>
    <li *ngIf="currentUserModel?.isImpersonated || ['A', 'F'].includes(currentUserModel?.loginType)">
      <label for="aliasCheck" (click)="clickAliasLogin($event)">
        <span *ngIf="!hasAliasLogin">Alias</span>
        <button *ngIf="hasAliasLogin"  class="button button-red button-mid" (click)="openAliasLogin($event, true)">Alias Again
        </button>
        <label class="switch">
          <input type="checkbox" id="aliasLoginCheck" [checked]="hasAliasLogin"
                 (change)="openAliasLogin($event, false)">
          <span class="slider round"></span>
        </label>
      </label>
    </li>
  </ul>
  <ng-template #aliasModal let-c="close" let-d="dismiss">
    <div class="alias-login-modal">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true" (click)="unCheckAlias()">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h4 class="modal-title">ALIAS LOGIN</h4>
        <ng2-completer id="accountNameOrId" [(ngModel)]="tempAccountId" [datasource]="dsAccountList"
                       [minSearchLength]="3" [pause]="100" [fillHighlighted]="false" class="completer-limit"
                       inputClass="form-control" [selectOnClick]="true" (selected)="onAccountSelected($event)"
                       textSearching="Searching accounts, please wait" (ngModelChange)="onAccountIdChange()"
                       [selectOnFocus]="false" placeholder="Search account by name or account code">
        </ng2-completer>
        <label>ACCOUNT</label>
        <span class="cart-name-modal col-md-12" id="companyName">{{companyName}}</span>
        <div class="input-control text">
          <label>LOGIN AS</label>
          <ng2-completer #loginListDropdown id="textContactName" class="completer-limit"
                         [(ngModel)]="contactName" [datasource]="dsContactList" [inputClass]="'form-control'"
                         [openOnFocus]="true" [minSearchLength]="0" [placeholder]="'Search login user'"
                         [selectOnFocus]="false" [fillHighlighted]="false" [selectOnClick]="true">
          </ng2-completer>

        </div>
        <button type="button" class="button add-cart-btn button-red col-md-12 btn-aliasLogin"
                (click)="aliasLogin()">
          Login
        </button>
        <button id="cancel-button" (click)="d('Cross click')">
          <label for="aliasCheck" (click)="unCheckAlias()">Cancel</label>
        </button>
      </div>
    </div>
  </ng-template>

</div>
<div class="menuContainer">
  <ng-template #sidecontainer></ng-template>
</div>
<loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)">
</loading-screen>